export function checkURLValidity(url) {
    let isValidURL = false;
    fetch(url, { method: 'HEAD' })
        .then(res => {
            if (res.ok) {
                console.debug("URL is valid: ", url);
                isValidURL = true;
            } else {
                console.debug("URL is not valid: ", url);
               isValidURL = false;
            }
        }).catch(err => console.error('checkURLValidity Error:', err));

    return isValidURL;
}